import React from 'react';
import PropTypes from 'prop-types';

const BusinessManager = ({ color }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8 6.78947V4.89474H10.2V6.78947H13.8ZM4.8 8.68421V19.1053H19.2V8.68421H4.8ZM19.2 6.78947C20.199 6.78947 21 7.63263 21 8.68421V19.1053C21 20.1568 20.199 21 19.2 21H4.8C3.801 21 3 20.1568 3 19.1053L3.009 8.68421C3.009 7.63263 3.801 6.78947 4.8 6.78947H8.4V4.89474C8.4 3.84316 9.201 3 10.2 3H13.8C14.799 3 15.6 3.84316 15.6 4.89474V6.78947H19.2Z"
        fill={color}
      />
    </svg>
  );
};

BusinessManager.propTypes = {
  color: PropTypes.string,
};
export default BusinessManager;
